import React from 'react';
import { call, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { httpRequestsOnSuccessActions } from '../http_requests_on_success';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';
import {
    CLONE_LIBRARY_GOAL,
    CREATE_LIBRARY_GOAL,
    DELETE_LIBRARY_GOAL,
    EDIT_LIBRARY_GOAL,
    GET_LIBRARY_GOAL_BY_ID,
    GET_LIBRARY_GOAL_BY_ID_SUCCESS,
    GET_LIBRARY_GOALS,
    GET_LIBRARY_GOALS_SUCCESS,
    GET_LIBRARY_FOLDERS_SUCCESS,
    GET_LIBRARY_FOLDERS,
    CREATE_LIBRARY_FOLDER,
    EDIT_LIBRARY_FOLDER,
    DELETE_LIBRARY_FOLDER,
    CREATE_LIBRARY_TARGET,
    EDIT_LIBRARY_TARGET,
    DELETE_LIBRARY_TARGET,
    CREATE_LIBRARY_OPTION,
    EDIT_LIBRARY_OPTION,
    DELETE_LIBRARY_OPTION,
    CREATE_LIBRARY_GOAL_TARGET,
    EDIT_LIBRARY_GOAL_TARGET,
    DELETE_LIBRARY_GOAL_TARGET,
    REORDER_LIBRARY_GOAL_TARGET,
    CHOOSE_TARGETS_FROM_LIBRARY_GOAL,
    CHOOSE_OPTIONS_FROM_LIBRARY_GOAL,
    CREATE_LIBRARY_GOAL_OPTION,
    EDIT_LIBRARY_GOAL_OPTION,
    DELETE_LIBRARY_GOAL_OPTION,
    REORDER_LIBRARY_GOAL_OPTION,
    CHANGE_LIBRARY_GOAL_TARGET_MASTERY,
    CHANGE_LIBRARY_GOAL_MASTERY,
    CHANGE_SINGLE_LIBRARY_GOAL_TARGET_MASTERY,
    REMOVE_SINGLE_LIBRARY_GOAL_TARGET_MASTERY,
    CHANGE_LIBRARY_TARGET_MAINTENANCE,
    ADD_LIBRARY_TARGET_MAINTENANCE_STEP,
    EDIT_LIBRARY_TARGET_MAINTENANCE_STEP,
    DELETE_LIBRARY_TARGET_MAINTENANCE_STEP,
    CHANGE_SINGLE_LIBRARY_TARGET_MAINTENANCE,
    ADD_SINGLE_LIBRARY_TARGET_MAINTENANCE_STEP,
    EDIT_SINGLE_LIBRARY_TARGET_MAINTENANCE_STEP,
    DELETE_SINGLE_LIBRARY_TARGET_MAINTENANCE_STEP,
    SINGLE_LIBRARY_TARGET_FOLLOW_GOAL_CONFIG,
    SINGLE_LIBRARY_TARGET_MASTERY_FOLLOW_GOAL,
    UPSERT_LIBRARY_SECTION_DESCRIPTION_BLOCK,
    DELETE_LIBRARY_SECTION_DESCRIPTION_BLOCK,
    /** End */
} from './library.types';
import { libraryService } from './library.service';
import { NotError } from 'components';

/** Goals */

// +

function* getLibraryGoals({ payload, type }) {
    if (payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(type));
    try {
        const res = yield call(libraryService.getLibraryGoalsService, payload?.params);
        yield put({
            type: GET_LIBRARY_GOALS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* createLibraryGoal({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const newGoal = yield call(libraryService.createLibraryGoalService, payload?.body);
        // Only the Library page has a list to refresh; callers elsewhere (client goal → "Save to Library") pass no params.
        if (payload?.requestParams) {
            const res = yield call(libraryService.getLibraryGoalsService, payload?.requestParams);
            yield put({
                type: GET_LIBRARY_GOALS_SUCCESS,
                payload: res.data,
            });
        }
        yield put(httpRequestsOnSuccessActions.appendSuccess(type, newGoal?.data));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* editLibraryGoal({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.editLibraryGoalService, payload?.id, payload?.body);
        const goalById = yield call(libraryService.getLibraryGoalByIdService, payload?.id);

        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });

        const res = yield call(libraryService.getLibraryGoalsService, payload?.requestParams);
        yield put({
            type: GET_LIBRARY_GOALS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type, goalById?.data));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* deleteLibraryGoal({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.deleteLibraryGoalService, payload?.id);
        const res = yield call(libraryService.getLibraryGoalsService, payload?.requestParams);
        yield put({
            type: GET_LIBRARY_GOALS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* cloneLibraryGoal({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const clonedGoal = yield call(libraryService.cloneLibraryGoalService, payload?.id, payload?.data);
        const res = yield call(libraryService.getLibraryGoalsService, payload?.requestParams);
        yield put({
            type: GET_LIBRARY_GOALS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type, clonedGoal?.data));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
        toast(<NotError errMessage={'Goal duplicated successfully'} />);
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* createLibraryGoalTarget({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.createLibraryGoalTargetService, payload?.goalId, payload?.body);
        const res = yield call(libraryService.getLibraryGoalByIdService, payload?.goalId);

        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* editLibraryGoalTarget({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.editLibraryGoalTargetService, payload?.goalId, payload?.targetId, payload?.body);
        const goalById = yield call(libraryService.getLibraryGoalByIdService, payload?.goalId);

        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });

        yield put(httpRequestsOnErrorsActions.removeError(type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* deleteLibraryGoalTarget({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.deleteLibraryGoalTargetService, payload?.goalId, payload?.targetId);
        const goalById = yield call(libraryService.getLibraryGoalByIdService, payload?.goalId);

        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* reorderLibraryGoalTarget({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.reorderLibraryGoalTargetService, payload?.goalId, payload?.reorder);
        const goalById = yield call(libraryService.getLibraryGoalByIdService, payload?.goalId);

        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

/** Mastery */
function* changeLibraryGoalTargetMastery({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.changeLibraryGoalTargetMasteryService, payload?.goalId, payload?.body);
        const goalById = yield call(libraryService.getLibraryGoalByIdService, payload?.goalId);

        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* changeLibraryGoalMastery({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.changeLibraryGoalMasteryService, payload?.goalId, payload?.body);
        const goalById = yield call(libraryService.getLibraryGoalByIdService, payload?.goalId);

        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* changeSingleLibraryGoalTargetMastery({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const res = yield call(
            libraryService.changeSingleLibraryGoalTargetMasteryService,
            payload?.goalId,
            payload?.targetId,
            payload?.body
        );

        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* removeSingleLibraryGoalTargetMastery({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const res = yield call(libraryService.removeSingleLibraryGoalTargetMasteryService, payload?.goalId, payload?.targetId);

        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

/** End */

/** Target Maintenance */

function* changeLibraryTargetMaintenance({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.changeLibraryTargetMaintenanceService, payload?.goalId, payload?.body);
        const goalById = yield call(libraryService.getLibraryGoalByIdService, payload?.goalId);

        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* addLibraryTargetMaintenanceStep({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.addLibraryTargetMaintenanceStepService, payload?.goalId, payload?.body);
        const goalById = yield call(libraryService.getLibraryGoalByIdService, payload?.goalId);

        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* editLibraryTargetMaintenanceStep({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.editLibraryTargetMaintenanceStepService, payload?.goalId, payload?.stepId, payload?.body);
        const goalById = yield call(libraryService.getLibraryGoalByIdService, payload?.goalId);

        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* deleteLibraryTargetMaintenanceStep({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.deleteLibraryTargetMaintenanceStepService, payload?.goalId, payload?.stepId);
        const goalById = yield call(libraryService.getLibraryGoalByIdService, payload?.goalId);

        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

/** End */

/** Single Target Maintenance */

function* changeSingleLibraryTargetMaintenance({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.changeSingleLibraryTargetMaintenanceService, payload?.goalId, payload?.targetId, payload?.body);
        const goalById = yield call(libraryService.getLibraryGoalByIdService, payload?.goalId);
        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* addSingleLibraryTargetMaintenanceStep({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.addSingleLibraryTargetMaintenanceStepService, payload?.goalId, payload?.targetId, payload?.body);
        const goalById = yield call(libraryService.getLibraryGoalByIdService, payload?.goalId);
        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* editSingleLibraryTargetMaintenanceStep({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.editSingleLibraryTargetMaintenanceStepService, payload?.goalId, payload?.stepId, payload?.body);

        const goalById = yield call(libraryService.getLibraryGoalByIdService, payload?.goalId);
        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* deleteSingleLibraryTargetMaintenanceStep({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.deleteSingleLibraryTargetMaintenanceStepService, payload?.goalId, payload?.targetId, payload?.stepId);
        const goalById = yield call(libraryService.getLibraryGoalByIdService, payload?.goalId);
        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* singleLibraryTargetFollowGoalConfig({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.singleLibraryTargetFollowGoalConfigService, payload?.goalId, payload?.targetId, payload?.body);
        const goalById = yield call(libraryService.getLibraryGoalByIdService, payload?.goalId);
        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* singleLibraryTargetMasteryFollowGoal({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.singleLibraryTargetMasteryFollowGoalService, payload?.goalId, payload?.targetId, payload?.body);
        const goalById = yield call(libraryService.getLibraryGoalByIdService, payload?.goalId);
        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

/** End */

function* createLibraryGoalOption({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.createLibraryGoalOptionService, payload?.goalId, payload?.body);
        const res = yield call(libraryService.getLibraryGoalByIdService, payload?.goalId);

        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* editLibraryGoalOption({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.editLibraryGoalOptionService, payload?.goalId, payload?.targetId, payload?.body);
        const goalById = yield call(libraryService.getLibraryGoalByIdService, payload?.goalId);

        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });

        yield put(httpRequestsOnErrorsActions.removeError(type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* deleteLibraryGoalOption({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.deleteLibraryGoalOptionService, payload?.goalId, payload?.targetId);
        const goalById = yield call(libraryService.getLibraryGoalByIdService, payload?.goalId);

        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* reorderLibraryGoalOption({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.reorderLibraryGoalOptionService, payload?.goalId, payload?.reorder);
        const goalById = yield call(libraryService.getLibraryGoalByIdService, payload?.goalId);

        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* chooseTargetsFromLibraryGoal({ payload, type }) {
    if (payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(libraryService.chooseTargetsFromLibraryGoalService, payload?.goalId, payload?.body);
        const goalById = yield call(libraryService.getLibraryGoalByIdService, payload?.goalId);

        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* chooseOptionsFromLibraryGoal({ payload, type }) {
    if (payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(libraryService.chooseOptionsFromLibraryGoalService, payload?.goalId, payload?.body);
        const goalById = yield call(libraryService.getLibraryGoalByIdService, payload?.goalId);

        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* upsertLibrarySectionDescriptionBlock({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.upsertLibrarySectionDescriptionBlockService, payload?.goalId, payload?.body);
        const goalById = yield call(libraryService.getLibraryGoalByIdService, payload?.goalId);
        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* deleteLibrarySectionDescriptionBlock({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.deleteLibrarySectionDescriptionBlockService, payload?.goalId, payload?.sectionTypeId);
        const goalById = yield call(libraryService.getLibraryGoalByIdService, payload?.goalId);
        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: goalById.data,
        });
        yield put(httpRequestsOnErrorsActions.removeError(type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* getLibraryGoalById({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
    try {
        const res = yield call(libraryService.getLibraryGoalByIdService, payload?.id);
        yield put({
            type: GET_LIBRARY_GOAL_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

/** End */

/** Clinical Library Folders */

function* getLibraryFolders({ payload, type }) {
    if (payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(type));
    try {
        const res = yield call(libraryService.getLibraryFoldersService, payload?.params);
        yield put({
            type: GET_LIBRARY_FOLDERS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* createLibraryFolder({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.createLibraryFolderService, payload?.body);
        const res = yield call(libraryService.getLibraryFoldersService, payload?.params);

        yield put({
            type: GET_LIBRARY_FOLDERS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* editLibraryFolder({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.editLibraryFolderService, payload?.id, payload?.body);
        const res = yield call(libraryService.getLibraryFoldersService, payload?.params);
        yield put({
            type: GET_LIBRARY_FOLDERS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnErrorsActions.removeError(type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* deleteLibraryFolder({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.deleteLibraryFolderService, payload?.id);
        const res = yield call(libraryService.getLibraryFoldersService, payload?.params);
        yield put({
            type: GET_LIBRARY_FOLDERS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

/** End */

/** Targets */

function* createLibraryTarget({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.createLibraryTargetService, payload?.folderId, payload?.body);
        const res = yield call(libraryService.getLibraryFoldersService, payload?.requestFoldersParams);

        yield put({
            type: GET_LIBRARY_FOLDERS_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* editLibraryTarget({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.editLibraryTargetService, payload?.folderId, payload?.targetId, payload?.body);
        const res = yield call(libraryService.getLibraryFoldersService, payload?.requestFoldersParams);

        yield put({
            type: GET_LIBRARY_FOLDERS_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* deleteLibraryTarget({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.deleteLibraryTargetService, payload?.folderId, payload?.targetId);
        const res = yield call(libraryService.getLibraryFoldersService, payload?.requestFoldersParams);

        yield put({
            type: GET_LIBRARY_FOLDERS_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

/** End */

/** Options */

function* createLibraryOption({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.createLibraryOptionService, payload?.folderId, payload?.body);
        const res = yield call(libraryService.getLibraryFoldersService, payload?.requestFoldersParams);

        yield put({
            type: GET_LIBRARY_FOLDERS_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* editLibraryOption({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.editLibraryOptionService, payload?.folderId, payload?.targetId, payload?.body);
        const res = yield call(libraryService.getLibraryFoldersService, payload?.requestFoldersParams);

        yield put({
            type: GET_LIBRARY_FOLDERS_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* deleteLibraryOption({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(libraryService.deleteLibraryOptionService, payload?.folderId, payload?.targetId);
        const res = yield call(libraryService.getLibraryFoldersService, payload?.requestFoldersParams);

        yield put({
            type: GET_LIBRARY_FOLDERS_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

/** End */

export const watchLibrary = function* watchLibraryAuth() {
    /** Goals  */
    yield takeLatest(GET_LIBRARY_GOALS, getLibraryGoals);
    yield takeLatest(GET_LIBRARY_GOAL_BY_ID, getLibraryGoalById);
    yield takeLatest(UPSERT_LIBRARY_SECTION_DESCRIPTION_BLOCK, upsertLibrarySectionDescriptionBlock);
    yield takeLatest(DELETE_LIBRARY_SECTION_DESCRIPTION_BLOCK, deleteLibrarySectionDescriptionBlock);
    yield takeLatest(CREATE_LIBRARY_GOAL, createLibraryGoal);
    yield takeLatest(EDIT_LIBRARY_GOAL, editLibraryGoal);
    yield takeLatest(DELETE_LIBRARY_GOAL, deleteLibraryGoal);
    yield takeLatest(CLONE_LIBRARY_GOAL, cloneLibraryGoal);

    yield takeLatest(CREATE_LIBRARY_GOAL_TARGET, createLibraryGoalTarget);
    yield takeLatest(EDIT_LIBRARY_GOAL_TARGET, editLibraryGoalTarget);
    yield takeLatest(DELETE_LIBRARY_GOAL_TARGET, deleteLibraryGoalTarget);
    yield takeLatest(REORDER_LIBRARY_GOAL_TARGET, reorderLibraryGoalTarget);

    yield takeLatest(CREATE_LIBRARY_GOAL_OPTION, createLibraryGoalOption);
    yield takeLatest(EDIT_LIBRARY_GOAL_OPTION, editLibraryGoalOption);
    yield takeLatest(DELETE_LIBRARY_GOAL_OPTION, deleteLibraryGoalOption);
    yield takeLatest(REORDER_LIBRARY_GOAL_OPTION, reorderLibraryGoalOption);

    yield takeLatest(CHOOSE_TARGETS_FROM_LIBRARY_GOAL, chooseTargetsFromLibraryGoal);
    yield takeLatest(CHOOSE_OPTIONS_FROM_LIBRARY_GOAL, chooseOptionsFromLibraryGoal);
    /** End */

    /** Mastery Library */
    yield takeLatest(CHANGE_LIBRARY_GOAL_TARGET_MASTERY, changeLibraryGoalTargetMastery);
    yield takeLatest(CHANGE_LIBRARY_GOAL_MASTERY, changeLibraryGoalMastery);
    yield takeLatest(CHANGE_SINGLE_LIBRARY_GOAL_TARGET_MASTERY, changeSingleLibraryGoalTargetMastery);
    yield takeLatest(REMOVE_SINGLE_LIBRARY_GOAL_TARGET_MASTERY, removeSingleLibraryGoalTargetMastery);
    /** End */

    /** Target Maintenance */
    yield takeLatest(CHANGE_LIBRARY_TARGET_MAINTENANCE, changeLibraryTargetMaintenance);
    yield takeLatest(ADD_LIBRARY_TARGET_MAINTENANCE_STEP, addLibraryTargetMaintenanceStep);
    yield takeLatest(EDIT_LIBRARY_TARGET_MAINTENANCE_STEP, editLibraryTargetMaintenanceStep);
    yield takeLatest(DELETE_LIBRARY_TARGET_MAINTENANCE_STEP, deleteLibraryTargetMaintenanceStep);
    /** End */

    /** Single Target Maintenance */
    yield takeLatest(CHANGE_SINGLE_LIBRARY_TARGET_MAINTENANCE, changeSingleLibraryTargetMaintenance);
    yield takeLatest(ADD_SINGLE_LIBRARY_TARGET_MAINTENANCE_STEP, addSingleLibraryTargetMaintenanceStep);
    yield takeLatest(EDIT_SINGLE_LIBRARY_TARGET_MAINTENANCE_STEP, editSingleLibraryTargetMaintenanceStep);
    yield takeLatest(DELETE_SINGLE_LIBRARY_TARGET_MAINTENANCE_STEP, deleteSingleLibraryTargetMaintenanceStep);
    yield takeLatest(SINGLE_LIBRARY_TARGET_FOLLOW_GOAL_CONFIG, singleLibraryTargetFollowGoalConfig);
    yield takeLatest(SINGLE_LIBRARY_TARGET_MASTERY_FOLLOW_GOAL, singleLibraryTargetMasteryFollowGoal);
    /** End */

    /** Clinical Library Folders */
    yield takeLatest(GET_LIBRARY_FOLDERS, getLibraryFolders);
    yield takeLatest(CREATE_LIBRARY_FOLDER, createLibraryFolder);
    yield takeLatest(EDIT_LIBRARY_FOLDER, editLibraryFolder);
    yield takeLatest(DELETE_LIBRARY_FOLDER, deleteLibraryFolder);
    /** End */

    /** Targets */
    yield takeLatest(CREATE_LIBRARY_TARGET, createLibraryTarget);
    yield takeLatest(EDIT_LIBRARY_TARGET, editLibraryTarget);
    yield takeLatest(DELETE_LIBRARY_TARGET, deleteLibraryTarget);
    /** End */

    /** Options */
    yield takeLatest(CREATE_LIBRARY_OPTION, createLibraryOption);
    yield takeLatest(EDIT_LIBRARY_OPTION, editLibraryOption);
    yield takeLatest(DELETE_LIBRARY_OPTION, deleteLibraryOption);
    /** End */
};
